module.exports = __webpack_public_path__ + "img/547595.50fa52d2.svg";